export enum MandrillEmailTemplateType {
  TeamInvitation = 'TeamInvitation',
  TeamInvitationAcceptedV2 = 'TeamInvitationAcceptedV2',
  TeamInvitationDeclinedV2 = ' TeamInvitationDeclinedV2',
  GroupMailWithLogo = 'GroupMailWithLogo',

  SurveyInvitation = 'SurveyInvitation',
  SurveyConfirmation = 'SurveyConfirmation',
  EvaluationInvitationCustom = 'EvaluationInvitationCustom',
  EvaluationConfirmation = 'EvaluationConfirmation',

  GenericEmailTemplate = 'GenericEmailTemplate',
}
